module.exports = __webpack_public_path__ + "static/media/close-circle.51060904.svg";